import React, { useState, useEffect } from 'react';
import { FaMapMarkedAlt, FaCalendarCheck, FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import BookingModal from './BookingModal';

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroImages = [
    {
      url: '/assets/wowimages/BANNER 1.JPG',
      title: 'Luxury Travel Caravans'
    },
    {
      url: '/assets/wowimages/BANNER 2.JPG',
      title: 'Spacious Family Caravans'
    },
    {
      url: '/assets/wowimages/BANNER 3.jpeg',
      title: 'Premium Caravan Experience'
    },
    {
      url: '/assets/wowimages/BANNER 4.jpg',
      title: 'Adventure Awaits'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroImages.length) % heroImages.length);
  };

  return (
    <>
      <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
        {/* Image Carousel Background */}
        <div className="absolute inset-0">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === currentSlide ? 'opacity-100' : 'opacity-0'
              }`}
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>

        {/* Carousel Controls */}
        <button
          onClick={prevSlide}
          className="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white p-4 rounded-full transition-all shadow-lg"
        >
          <FaChevronLeft className="text-2xl" />
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white p-4 rounded-full transition-all shadow-lg"
        >
          <FaChevronRight className="text-2xl" />
        </button>

        {/* Slide Indicators */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex gap-2">
          {heroImages.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full transition-all ${
                index === currentSlide
                  ? 'bg-white w-8'
                  : 'bg-white/50 hover:bg-white/75'
              }`}
            />
          ))}
        </div>
        
        {/* Overlay gradient */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/50 to-black/70" />

        {/* Hero Content */}
        <div className="container-custom relative z-10 py-32">
          <div className="max-w-3xl text-white space-y-6">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight drop-shadow-2xl">
              Your Holiday On
              <span className="block text-accent-400">Wheel Awaits</span>
            </h1>

            <div className="flex flex-wrap gap-4 pt-4">
              <button
                onClick={() => setIsModalOpen(true)}
                className="flex items-center space-x-2 px-8 py-4 bg-accent-500 text-white font-bold rounded-full hover:bg-accent-600 transition-all shadow-xl hover:shadow-2xl transform hover:-translate-y-1"
              >
                <FaCalendarCheck />
                <span>Book Now</span>
              </button>
              <button
                onClick={() => setIsModalOpen(true)}
                className="flex items-center space-x-2 px-8 py-4 bg-white/10 backdrop-blur-md text-white font-bold rounded-full hover:bg-white/20 border-2 border-white transition-all shadow-xl hover:shadow-2xl transform hover:-translate-y-1"
              >
                <FaMapMarkedAlt />
                <span>Plan a Trip</span>
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Booking Modal */}
      <BookingModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default Hero;
